import Swiper from 'swiper'
import { Autoplay, Grid, Navigation, Pagination, Scrollbar, Thumbs } from 'swiper/modules'
import { media } from '../../plugins/media'

declare global {
  interface Window {
    Swiper: typeof Swiper
  }
}

Swiper.use([Navigation, Pagination, Scrollbar, Autoplay, Grid, Thumbs])
Swiper.defaults.touchStartPreventDefault = false
window.Swiper = Swiper

const { sm, md, lg, xl } = media

const createAdvantagesSlider = (): void => {
  const slider = document.querySelector('*[data-slider="advantages"]') as HTMLDivElement

  if (!slider) return

  const value: string = String(slider.dataset.slider)
  const swiper = slider.querySelector(`*[data-slider-swiper="${value}"]`) as HTMLDivElement
  const pagination = slider.querySelector(`*[data-slider-pagination="${value}"]`) as HTMLDivElement
  const prev = slider.querySelector(`*[data-slider-prev="${value}"]`) as HTMLButtonElement
  const next = slider.querySelector(`*[data-slider-next="${value}"]`) as HTMLButtonElement

  new window.Swiper(swiper, {
    pagination: {
      el: pagination,
      clickable: true,
    },
    navigation: {
      prevEl: prev,
      nextEl: next,
    },
    slidesPerView: 1,
    slidesPerGroup: 1,
    spaceBetween: 16,
    grabCursor: true,
    watchSlidesProgress: true,
    breakpoints: {
      [sm]: {
        slidesPerView: 1.2,
        spaceBetween: 20,
      },
      [md]: {
        slidesPerView: 1.5,
        spaceBetween: 24,
      },
      [lg]: {
        slidesPerView: 2,
        spaceBetween: 28,
      },
      [xl]: {
        slidesPerView: 2,
        spaceBetween: 44,
      },
    },
  }) as Swiper
}

export default (): void => createAdvantagesSlider()
